import NotificationIcon from "@assets/icons/notification.svg";
import { useNavigate } from "@core/routing/use-navigate";
import { notificationBadgeManager } from "@core/service-container";
import styled from "@emotion/styled";
import { RoutesPath } from "@ui/navigation/routes";
import { physioMeTabletBreakpoint } from "@ui/style";
import { colors } from "@ui/style/colors";
import { useObservable } from "micro-observables";
import React, { useCallback, useMemo, useState } from "react";
import { useLocation } from "react-router";

export const NotificationCenterIcon: React.FC = () => {
	const shouldDisplayBadge = useObservable(notificationBadgeManager.shouldDisplayBadge);
	const navigate = useNavigate();
	const location = useLocation();

	const [isHovered, setIsHovered] = useState(false);
	const isTabActive = useMemo(() => location.pathname === RoutesPath.NotificationCenter, [location]);

	const onContainerClick = useCallback(() => {
		notificationBadgeManager.saveLastUnreadCount();
		navigate(RoutesPath.NotificationCenter);
	}, [navigate]);

	return (
		<Container
			active={isTabActive}
			onClick={onContainerClick}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			<IconContainer>
				<NotificationIcon width={24} height={24} color={isTabActive || isHovered ? colors.primary : colors.black} />
				{shouldDisplayBadge && <NotificationBadge isHovered={isHovered} />}
			</IconContainer>
		</Container>
	);
};

const Container = styled.div<{ active: boolean }>`
	cursor: pointer;
	border-bottom: ${({ active }) => (active ? "2px" : "0px")} solid ${colors.primary};
	align-self: stretch;
	display: flex;
	align-items: center;
	margin-bottom: -3px;
	padding: 0 8px;
	border-radius: 12px 12px 0 0;

	:hover {
		background-color: ${colors.primary10};
	}

	@media ${physioMeTabletBreakpoint} {
		margin-bottom: 0;
	}
`;

const IconContainer = styled.div`
	position: relative;
`;

const NotificationBadge = styled.div<{ isHovered: boolean }>`
	position: absolute;
	top: 1px;
	right: 1px;
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: ${colors.rejection};
	border: 2px solid ${({ isHovered }) => (isHovered ? `${colors.primary10}` : `${colors.white}`)};
`;
